export default function SimDetail() {
  return (
    <div className="flex w-full justify-center items-center">
      <div>Nov 19, 2025 (Wed)</div>
    </div>
  );
}
